// features/candidates/reducers.js
import {
    SEARCH_QUERY_FAILURE,
    SEARCH_QUERY_SUCCESS,
    SEARCH_QUERY_REQUEST,
  } from './candidateAction';
  
  const initialState = {
    query: [],
    loading: false,
    error: null,
  };
  
  const queryReducer = (state = initialState, action) => {
    switch (action.type) {
      case SEARCH_QUERY_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case SEARCH_QUERY_SUCCESS:
        return {
          ...state,
          loading: false,
          query: action.payload,
        };
      case SEARCH_QUERY_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default queryReducer;
  